/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { FormattedMessage } from '@modules/i18n'

import LandingPage from '../../../../../components/LandingPage'

import { getTokenAndStateThenRedirect } from './lib'

import type { Props } from './lib'

const SsoReceiveToken: React.FunctionComponent<Props> = ({ saveAuthExpiration, redirect }) => {
  const location = useLocation()

  useEffect(() => {
    getTokenAndStateThenRedirect({ saveAuthExpiration, redirect, location })
  }, [])

  return (
    <LandingPage loading={true}>
      <div>
        <FormattedMessage
          id='sso-receive-token.authenticating'
          defaultMessage='Authenticating...'
        />
      </div>
    </LandingPage>
  )
}

export default SsoReceiveToken
